import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  root: {
    paddingLeft: "1rem",
    maxWidth: "1040px",
    "@media(max-width: 900px)": {
      paddingLeft: 0,
    },
  },
  pageTitle: {
    marginTop: 0,
    marginBottom: "0.25rem",
  },
  pageSubtitle: {
    marginTop: 0,
    marginBottom: "1.5rem",
    color: "#605e5c",
  },
  card: {
    paddingLeft: "2.5rem",
    paddingRight: "2.5rem",
    paddingTop: "2rem",
    paddingBottom: "2rem",
    backgroundColor: "#fff",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
    borderBottomLeftRadius: "16px",
    borderBottomRightRadius: "16px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    marginBottom: "1.5rem",
  },
  cardTitle: {
    marginTop: 0,
    marginBottom: "0.25rem",
  },
  cardSubtitle: {
    marginTop: 0,
    marginBottom: "1rem",
    color: "#605e5c",
  },
  fieldLabel: {
    display: "block",
    marginBottom: "0.25rem",
    marginTop: "0.75rem",
    fontWeight: 600,
  },
  notSavedLabel: {
    display: "block",
    marginBottom: "0.25rem",
    marginTop: "0.75rem",
    fontWeight: 600,
    color: "#c19c00",
  },
  mb16: {
    marginBottom: "1rem",
  },
  intervalRow: {
    display: "flex",
    alignItems: "center",
    columnGap: "0.75rem",
  },
  intervalInput: {
    maxWidth: "180px",
  },
  hoursLabel: {
    color: "#605e5c",
  },
  saveIntervalButton: {
    marginLeft: "auto",
  },
  licenseRow: {
    display: "flex",
    columnGap: "0.75rem",
  },
  licenseInput: {
    flexGrow: 1,
  },
  productDropdown: {
    minWidth: "180px",
  },
  dropdownSearchBox: {
    paddingLeft: "8px",
    paddingRight: "8px",
    paddingTop: "8px",
    paddingBottom: "8px",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    borderBottomColor: "#edebe9",
  },
  btnRow: {
    display: "flex",
    columnGap: "0.75rem",
    marginTop: "0.75rem",
  },
  chipRow: {
    display: "flex",
    flexWrap: "wrap",
    columnGap: "0.5rem",
    rowGap: "0.5rem",
  },
  chipSaved: {
    display: "inline-flex",
    alignItems: "center",
    columnGap: "0.35rem",
    paddingLeft: "0.75rem",
    paddingRight: "0.5rem",
    paddingTop: "0.3rem",
    paddingBottom: "0.3rem",
    borderTopLeftRadius: "9999px",
    borderTopRightRadius: "9999px",
    borderBottomLeftRadius: "9999px",
    borderBottomRightRadius: "9999px",
    backgroundColor: "#e5f1fb",
    color: "#0078d4",
    fontSize: "0.85rem",
  },
  chipPending: {
    display: "inline-flex",
    alignItems: "center",
    columnGap: "0.35rem",
    paddingLeft: "0.75rem",
    paddingRight: "0.5rem",
    paddingTop: "0.3rem",
    paddingBottom: "0.3rem",
    borderTopLeftRadius: "9999px",
    borderTopRightRadius: "9999px",
    borderBottomLeftRadius: "9999px",
    borderBottomRightRadius: "9999px",
    borderTopWidth: "1px",
    borderBottomWidth: "1px",
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderTopStyle: "dashed",
    borderBottomStyle: "dashed",
    borderLeftStyle: "dashed",
    borderRightStyle: "dashed",
    borderTopColor: "#c19c00",
    borderBottomColor: "#c19c00",
    borderLeftColor: "#c19c00",
    borderRightColor: "#c19c00",
    backgroundColor: "#fff9e6",
    color: "#8a6d00",
    fontSize: "0.85rem",
  },
  chipRemoveIcon: {
    fontSize: "0.7rem",
    cursor: "pointer",
  },
  addRecipientRow: {
    display: "flex",
    columnGap: "0.5rem",
    alignItems: "center",
  },
  addRecipientInput: {
    flexGrow: 1,
  },
  addRecipientButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    borderTopWidth: "1px",
    borderBottomWidth: "1px",
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopColor: "#8a8886",
    borderBottomColor: "#8a8886",
    borderLeftColor: "#8a8886",
    borderRightColor: "#8a8886",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
  successBanner: {
    marginTop: "0.75rem",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "0.75rem",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    backgroundColor: "#dff6dd",
    color: "#107c10",
  },
  errorBanner: {
    marginTop: "0.75rem",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "0.75rem",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    backgroundColor: "#fde7e9",
    color: "#a80000",
  },
  inlineError: {
    display: "block",
    marginTop: "0.35rem",
    color: "#a80000",
    fontSize: "0.8rem",
  },
});
